// extracted by mini-css-extract-plugin
export default {"autosuggest_wrapper":"UserSearch_autosuggest_wrapper__yZ9rB"};